exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host .mat-list-item-content {\r\n\theight: auto !important;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/TMB/TMB/MYTMB.UI/src/app/pages/view-prescriptions/view-prescriptions.component.css
// module id = ../../../../../src/app/pages/view-prescriptions/view-prescriptions.component.css
// module chunks = main